<template>
  <div class="modal fade" id="fetchDomains" tabindex="-1" role="dialog" aria-labelledby="fetchAndAddFromHostBill" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Synchronize Domains to WPO</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <label class="col-sm-2 col-md-2 col-lg-2 text-center col-form-label">Server IP
              <strong class="text-danger">*</strong>
            </label>
            <div class="col-sm-8 col-md-8 col-lg-8">
              <div class="form-group">
                <input type="text" class="form-control" v-model="serverIP" placeholder="Please enter server IP to fetch domains" required >
              </div>
            </div>
            <div class="col-sm-2 col-md-2 col-lg-2">
              <button @click="fetchAllDomains" :disabled="submitLoader" class="btn btn-sm btn-primary pull-right" type="button">
                <div v-if="submitLoader" class="loader mini_loader"></div>
                <span v-else>Submit</span>
              </button>
            </div>
          </div>
          <!--          <div class="row">-->
          <!--            <div class="col-md-12">-->
          <!--              <button @click="fetchAllDomains" :disabled="submitLoader" class="btn btn-sm btn-primary pull-right" type="button">-->
          <!--                <div v-if="submitLoader" class="loader mini_loader"></div>-->
          <!--                <span v-else>Submit</span>-->
          <!--              </button>-->
          <!--            </div>-->
          <!--          </div>-->
          <section v-if="showDomains && serverDomains.length">
            <div class="row pl-15 pr-15 mt-10">
              <div class="col-md-4 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedValue" type="radio" name="checkAllDomains" id="inputDomain" value="checkAll"> Check all domains
                  <span class="form-check-sign"></span>
                </label>
              </div>
              <div class="col-md-4 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedValue" type="radio" name="uncheckAllDomains" id="status" value="uncheckAll"> Uncheck all domains
                  <span class="form-check-sign"></span>
                </label>
              </div>
              <div class="col-md-4 form-check-radio">
                <label class="form-check-label">
                  <input class="form-check-input" v-model="selectedValue" type="radio" name="uncheckExistingDomains" id="jobName" value="uncheckExisting"> Uncheck domains that exist already
                  <span class="form-check-sign"></span>
                </label>
              </div>
            </div>
            <div v-if="!planExistsFlag" class="row">
              <div class="col-md-6">
                <label>Select Plan:</label>
                <select class="form-control h-43" v-model="newPlan.details" required>
                  <option v-for="(row) in planList" :value="row">
                    {{ row.name }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <label>Select Primary:</label>
                <select class="form-control h-43" v-model="newPlan.primary" required>
                  <option :key="index" v-for="(row, index) in checkAll" :value="row">
                    {{ row.domain }}
                  </option>
                </select>
              </div>
              <div class="col-md-4 mt-10">
                <label>Cloudflare Username</label>
                <div class="form-group">
                  <input placeholder="Username" type="text" class="form-control" v-model="newPlan.cloudflare.username">
                </div>
              </div>
              <div class="col-md-4 mt-10">
                <label>Cloudflare Password</label>
                <div class="form-group">
                  <input placeholder="Password" type="text" class="form-control" v-model="newPlan.cloudflare.password">
                </div>
              </div>
              <div class="col-md-4 mt-10">
                <label>Cloudflare Api Key</label>
                <div class="form-group">
                  <input placeholder="Api Key" type="text" class="form-control" v-model="newPlan.cloudflare.apiKey">
                </div>
              </div>
            </div>
            <!--            <div class="row">-->
            <!--              <div class="col-md-12">-->
            <!--                <button class="btn btn-primary pull-right" @click="syncDomains">Add domains to server</button>-->
            <!--              </div>-->

            <!--            </div>-->
            <div class="row mt-5">
              <div class="col-md-12 mb-3">
                <input
                  v-model="domainSearchQuery"
                  type="text"
                  class="form-control"
                  placeholder="Search domains..."
                  style="max-width: 300px;"
                />
              </div>
              <perfect-scrollbar class="scroll-area col-md-12">
                <table class="table single-outage-table">
                  <thead>
                  <tr>
                    <th></th>
                    <th><b>Domain Name</b></th>
                    <th class="text-center">Action</th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(row, index) in paginatedArrangedServerDomain">
                    <tr :class="[ifExisting(row.domain) ? 'table-warning' : '', row.isStagingOnly ? 'staging-only-row' : '']">
                      <td></td>
                      <td>
                        <span v-if="row.isStagingOnly" class="staging-domain">Staging only: {{ row.domain }}</span>
                        <span v-else>{{ row.domain }}</span>
                      </td>
                      <td>
                        <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center">
                          <template v-if="row.isStagingOnly">
                            <input type="checkbox" class="custom-control-input" name="identifiers" v-model="checkStaging" :value="row.stagingOnlyObject" :id="'domain-' + domainPageNum + '-' + index" />
                            <label class="custom-control-label" :for="'domain-' + domainPageNum + '-' + index"></label>
                          </template>
                          <template v-else>
                            <input type="checkbox" class="custom-control-input" name="identifiers" v-model="checkAll" :value="row" :id="'domain-' + domainPageNum + '-' + index" @click="removeStagingWithLiveDomain(row)"/>
                            <label class="custom-control-label" :for="'domain-' + domainPageNum + '-' + index"></label>
                          </template>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="row.staging && !row.isStagingOnly">
                      <td class="dotted-td">
                      </td>
                      <td>
                        <div class="dotted-line-text domain-hover">
                          <div
                              class="dotted-line"
                          />
                          <span :class="'staging-domain'">{{row.staging.domain}}</span>

                        </div>
                      </td>
                      <td>
                        <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center">
                          <input type="checkbox" class="custom-control-input" name="identifiers" v-model="checkStaging" :value="row.staging" :id="'staging-' + domainPageNum + '-' + index" @click="addLiveToSelectedWithStaging(row)" />
                          <label class="custom-control-label" :for="'staging-' + domainPageNum + '-' + index"></label>
                        </div>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </perfect-scrollbar>
              <div v-if="filteredArrangedServerDomain.length > domainPageSize" class="col-md-12 mt-3 d-flex align-items-center justify-content-between">
                <span class="text-muted">Showing {{ domainPageNum * domainPageSize + 1 }}-{{ Math.min((domainPageNum + 1) * domainPageSize, filteredArrangedServerDomain.length) }} of {{ filteredArrangedServerDomain.length }} domains</span>
                <div>
                  <button type="button" class="btn btn-sm btn-outline-secondary mr-2" :disabled="domainPageNum === 0" @click="domainPageNum = Math.max(0, domainPageNum - 1)">
                    Previous
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary" :disabled="domainPageNum >= totalDomainPages - 1" @click="domainPageNum = Math.min(totalDomainPages - 1, domainPageNum + 1)">
                    Next
                  </button>
                </div>
              </div>
            </div>
            <section class="row mt-5 pull-right">
              <button :disabled="finalLoader" type="button" class="btn btn-primary" @click="syncDomains">
                <div v-if="finalLoader" class="loader mini_loader"></div>
                <span v-else>Add domains to WPO</span>
              </button>
            </section>
          </section>
          <section v-else-if="showDomains && serverDomains.length === 0">
            <span>No Domains Available!</span>
          </section>
        </div>
        <!--        <div class="modal-footer">-->
        <!--          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>-->
        <!--          <button :disabled="finalLoader" type="button" class="btn btn-primary pull-right" @click="syncDomains">-->
        <!--            <div v-if="finalLoader" class="loader mini_loader"></div>-->
        <!--            <span v-else>Add domains to WPO</span>-->
        <!--          </button>-->

        <!--        </div>-->
      </div>
    </div>
  </div>

</template>

<script>
import swal from "sweetalert2";
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import {db} from "@/firebase/init";
import {v4 as uuidv4} from "uuid";

export default {
  name: "fetchDomainModal",
  components: {
    PerfectScrollbar
  },
  props: ['syncUuids'],
  data () {
    return {
      submitLoader: false,
      finalLoader: false,
      selectedValue: 'checkAll',
      serverIP: '69.162.173.212',
      existingDomains: [],
      checkAll: [],
      checkStaging: [],
      showDomains: false,
      planList: [],
      newPlan: {
        details: null,
        primary: null,
        cloudflare: {
          username: '',
          password: '',
          apiKey: ''
        }
      },
      serverDomains: [],
      planExistsFlag: false,
      domainPageSize: 50,
      domainPageNum: 0,
      domainSearchQuery: ''
    }
  },
  computed: {
    docID() {
      return this.$store.getters["customer/docID"];
    },
    custID() {
      return this.$store.getters["customer/id"];
    },
    user() {
      return this.$store.getters.user;
    },
    customerInfo () {
      return this.$store.getters["customer/details"];
    },
    /** Set of existing domain names for O(1) lookup */
    existingDomainsSet() {
      const set = new Set();
      this.existingDomains.forEach(el => {
        if (el.domain) set.add(el.domain);
      });
      return set;
    },
    /** Staging-only domains (pure, no side effects) */
    stagingDomains() {
      return this.serverDomains.filter(obj => obj.domain && obj.domain.includes('.bigscoots-staging.com'));
    },
    /** Live domains with staging attached; staging-only domains (no live counterpart) appended so they show in the list */
    arrangedServerDomain() {
      const stagingByDomain = new Map();
      this.stagingDomains.forEach(s => stagingByDomain.set(s.domain, s));
      const live = this.serverDomains.filter(obj => obj.domain && !obj.domain.includes('.bigscoots-staging.com'));
      const usedStagingDomains = new Set();
      const result = live.map(domainObj => {
        const assumeStaging = domainObj.domain.replace(/\./g, '') + '.bigscoots-staging.com';
        const staging = stagingByDomain.get(assumeStaging);
        if (staging) usedStagingDomains.add(staging.domain);
        return staging ? { ...domainObj, staging } : { ...domainObj };
      });
      // Append staging-only domains (e.g. maksteelcom.bigscoots-staging.com with no live maksteel.com)
      this.stagingDomains.forEach(s => {
        if (!usedStagingDomains.has(s.domain)) {
          result.push({ domain: s.domain, staging: null, isStagingOnly: true, stagingOnlyObject: s });
        }
      });
      return result;
    },
    filteredArrangedServerDomain() {
      const q = (this.domainSearchQuery || '').toLowerCase().trim();
      if (!q) return this.arrangedServerDomain;
      return this.arrangedServerDomain.filter(row =>
        (row.domain && row.domain.toLowerCase().includes(q)) ||
        (row.staging && row.staging.domain.toLowerCase().includes(q)) ||
        (row.isStagingOnly && row.domain && row.domain.toLowerCase().includes(q))
      );
    },
    totalDomainPages() {
      return Math.max(1, Math.ceil(this.filteredArrangedServerDomain.length / this.domainPageSize));
    },
    paginatedArrangedServerDomain() {
      const start = this.domainPageNum * this.domainPageSize;
      return this.filteredArrangedServerDomain.slice(start, start + this.domainPageSize);
    }
  },
  watch: {
    domainSearchQuery() {
      this.domainPageNum = 0;
    },
    selectedValue (val) {
      if (val === 'checkAll') {
        this.checkAll=[]
        this.checkStaging=[]
        for (const row of this.arrangedServerDomain) {
          this.checkAll.push(row)
        }
        for (const row of this.stagingDomains) {
          this.checkStaging.push(row)
        }
      } else if (val === 'uncheckAll') {
        this.checkAll = [];
        this.checkStaging = [];
      } else if (val === 'uncheckExisting') {
        this.checkAll = [];
        this.checkStaging = [];
        for (const row of this.arrangedServerDomain) {
          if(!this.ifExisting(row.domain)) {
            this.checkAll.push(row)
          }
        }
        for (const row of this.stagingDomains) {
          if(!this.ifExisting(row.domain)) {
            this.checkStaging.push(row)
          }
        }
      }
      // if (val) {
      //   for (const row of this.serverDomains) {
      //     this.checkAll.push(row.domain)
      //   }
      // }
    },
    // checkAll () {
    //   this.newPlan = {
    //     details: null,
    //     primary: null
    //   }
    // }
  },
  methods: {
    async fetchPlans () {
      const planRef = await db.collection('plans').orderBy('order').get();
      planRef.forEach((plan) => {
        this.planList.push({ id: plan.id, ...plan.data() });
      });
    },
    async saveDomainsForCollaborators () {
      const ref = await db.collection('users').doc(this.docID).get();
      if (ref.exists) {
        const { collaborators } = ref.data();
        if (collaborators && collaborators.length) {
          for (const row of collaborators) {
            if (row.futureAccess) {
              for (const selected of this.checkAll) {
                console.log('domain exists',row.domains.includes(selected.domain) )
                if (!row.domains.includes(selected.domain)) {
                  row.domains.push(selected.domain);
                }
              }
              await db.collection('users').doc(this.docID).update({ collaborators })
              if (row.uid) {
                const collabRef = await db.collection('users').doc(row.uid).get();
                if (collabRef.exists) {
                  const { supervisors } = collabRef.data();
                  if (supervisors && supervisors.length) {
                    for (const supervisorRow of supervisors) {
                      if (supervisorRow.futureAccess) {
                        for (const el of this.checkAll) {
                          if (!supervisorRow.allowedDomains.includes(el.domain)) {
                            supervisorRow.allowedDomains.push(el.domain);
                          }
                        }
                      }
                    }
                    await db.collection('users').doc(row.uid).update({ supervisors });
                  }
                }
              }
            }
          }
        }
      }
    },
    async syncDomains () {
      try {
        console.log(this.newPlan)
        if(!this.checkAll.length) {
          return;
        }
        if (!this.planExistsFlag) {
          if (!this.newPlan.primary || !this.newPlan.details) {
            swal({
              title: "Error",
              text: 'Please select plan and primary domain first',
              type: "error",
            });
            return;
          } else {
            const obj = this.checkAll.find(el => el.domain === this.newPlan.primary.domain)
            if (!obj) {
              swal({
                title: "Error",
                text: 'Please select primary domain from selected domains.',
                type: "error",
              });
              return;
            }
          }
        }
        this.finalLoader = true;
        this.checkAll.forEach(el => el.uuid = uuidv4())
        console.log('return ', this.checkAll)
        // get hosting Account
        const ref = await db.collection('hostingAccounts').doc(this.docID).get();
        let planIndex= null;
        if (ref.exists) {
          console.log('inside')
          const { accounts } = ref.data();
          const beforePayload = JSON.parse(JSON.stringify(accounts))
          let cloudflareDomain = ''
          if (this.planExistsFlag) {
            accounts.forEach((el, index) => {
              console.log(el.primary.serverIP, this.serverIP)
              if (el.primary.serverIP === this.serverIP) {
                planIndex = index;
                cloudflareDomain = el.primary.domain
                for (const row of this.checkAll) {
                  const obj = {
                    serverIP: this.serverIP,
                    sslFlag: false,
                    aliases: [],
                    domain: row.domain,
                    manualBackups: [],
                    tags: [],
                    notes: [],
                    chargable: false,
                    uuid: row.uuid,
                    status: 'active',
                    deleted: false,
                    comparisonID: '',
                    flushOpcacheURL: '',
                    freashInstall: false,
                    statusCakeTestId: '',
                    monitorId: '',
                    redirects: [],
                    cloudflarePlan: 'free',
                    installation_type: '',
                    home_path: `/home/nginx/domains/${row.domain}`,
                    ftp: {
                      host: this.serverIP,
                      port: '',
                      mode: '',
                      pasv: '',
                      username: '',
                      password: '',
                      accounts: []
                    },
                    phpMyAdmin: {
                      url: row.phpMyAdmin.url,
                      popupUsername: row.phpMyAdmin.popupUsername,
                      popupPassword: row.phpMyAdmin.popupPassword,
                      username: row.phpMyAdmin.username,
                      password: row.phpMyAdmin.password
                    },
                    cloudflare: {
                      username: '',
                      password: '',
                      userKey: '',
                      apiKey: '',
                      zone_id: '',
                      nameserver1: '',
                      nameserver2: ''
                    },
                    diskSpace: [],
                    staging: {
                      enabled: false,
                      domain: '',
                      flushOpcacheURL: '',
                      freashInstall: false,
                      statusCakeTestId: '',
                      redirects: [],
                      manualBackups: [],
                      tags: [],
                      diskSpace: [],
                      ftp: {
                        host: '',
                        port: '',
                        mode: '',
                        pasv: '',
                        username: '',
                        password: '',
                        accounts: []
                      },
                      phpMyAdmin: {
                        url: '',
                        popupUsername: '',
                        popupPassword: '',
                        username: '',
                        password: ''
                      }
                    }
                  }
                  if (row.staging) {
                    const stagingIndexInChecked = this.checkStaging.findIndex(e => e.domain === row.staging.domain)
                    if (stagingIndexInChecked !== -1) {
                      const domainObj = this.checkStaging[stagingIndexInChecked];
                      obj.staging.domain = domainObj.domain;
                      // obj.staging.ftp=domainObj.ftp;
                      // obj.staging.ftp.host = this.serverIP
                      obj.staging.phpMyAdmin = domainObj.phpMyAdmin;
                      obj.staging.enabled = true;
                    }
                  }
                  console.log(' obj is complete')
                  el.addon.push(obj);
                }
                if ((Number(el.planLimit) + Number(el.extraDomains)) < el.addon.length + 1) {
                  console.log('inside addon limit')
                  el.extraDomains = (el.addon.length + 1) - Number(el.planLimit);
                }
                console.log('updated account', el.addon)
              }
            })
          } else {
            cloudflareDomain = this.newPlan.primary.domain
            const obj = {
              planName: this.newPlan.details.name,
              migration: {
                count: 0,
                log: []
              },
              primary: {
                sslFlag: false,
                aliases: [],
                manualBackups: [],
                tags: [],
                notes: [],
                chargable: false,
                deleted: false,
                statusCakeTestId: '',
                monitorId: '',
                redirects: [],
                cloudflarePlan: 'free',
                installation_type: '',
                home_path: `/home/nginx/domains/${this.newPlan.primary.domain}`,
                serverIP: this.serverIP,
                hbServiceID: '',
                solusVM_VPS_ID: '',
                hbHostname: this.newPlan.primary.domain,
                domain: this.newPlan.primary.domain,
                status: 'active',
                comparisonID: '',
                flushOpcacheURL: '',
                freashInstall: false,
                ftp: {
                  host: this.serverIP,
                  port: '',
                  mode: '',
                  pasv: '',
                  username: '',
                  password: '',
                  accounts: []
                },
                phpMyAdmin: {
                  url: this.newPlan.primary.phpMyAdmin.url,
                  popupUsername: this.newPlan.primary.phpMyAdmin.popupUsername,
                  popupPassword: this.newPlan.primary.phpMyAdmin.popupPassword,
                  username: this.newPlan.primary.phpMyAdmin.username,
                  password: this.newPlan.primary.phpMyAdmin.password
                },
                cloudflare: {
                  username: '',
                  password: '',
                  userKey: '',
                  apiKey: '',
                  zone_id: '',
                  nameserver1: '',
                  nameserver2: ''
                },
                staging: {
                  enabled: false,
                  domain: "",
                  flushOpcacheURL: "",
                  freashInstall: false,
                  ftp: {
                    host: "",
                    port: "21",
                    mode: "FTP (explicit SSL)",
                    pasv: "Ensure is Checked/Enabled",
                    username: "",
                    password: "",
                    accounts: []
                  },
                  phpMyAdmin: {
                    url: "",
                    popupUsername: "",
                    popupPassword: "",
                    username: "",
                    password: ""
                  }
                }
              },
              planLimit: this.newPlan.details.planLimit,
              extraDomains: 0,
              maxStorageSize: this.newPlan.details.maxStorageSize,
              maxVisitors: this.newPlan.details.visitors,
              addon: []
            }
            for (const row of this.checkAll) {
              if (row.domain === this.newPlan.primary.domain) {
                continue;
              }
              const addon = {
                uuid: row.uuid,
                serverIP: this.serverIP,
                sslFlag: false,
                aliases: [],
                domain: row.domain,
                manualBackups: [],
                tags: [],
                notes: [],
                chargable: false,
                status: 'active',
                deleted: false,
                comparisonID: '',
                flushOpcacheURL: '',
                freashInstall: false,
                statusCakeTestId: '',
                monitorId: '',
                redirects: [],
                cloudflarePlan: 'free',
                installation_type: '',
                home_path: `/home/nginx/domains/${row.domain}`,
                ftp: {
                  host: this.serverIP,
                  port: '',
                  mode: '',
                  pasv: '',
                  username: '',
                  password: '',
                  accounts: []
                },
                phpMyAdmin: {
                  url: row.phpMyAdmin.url,
                  popupUsername: row.phpMyAdmin.popupUsername,
                  popupPassword: row.phpMyAdmin.popupPassword,
                  username: row.phpMyAdmin.username,
                  password: row.phpMyAdmin.password
                },
                cloudflare: {
                  username: '',
                  password: '',
                  userKey: '',
                  apiKey: '',
                  zone_id: '',
                  nameserver1: '',
                  nameserver2: ''
                },
                diskSpace: [],
                staging: {
                  enabled: false,
                  domain: '',
                  flushOpcacheURL: '',
                  freashInstall: false,
                  statusCakeTestId: '',
                  redirects: [],
                  manualBackups: [],
                  tags: [],
                  diskSpace: [],
                  ftp: {
                    host: '',
                    port: '',
                    mode: '',
                    pasv: '',
                    username: '',
                    password: '',
                    accounts: []
                  },
                  phpMyAdmin: {
                    url: '',
                    popupUsername: '',
                    popupPassword: '',
                    username: '',
                    password: ''
                  }
                }
              }
              if (row.staging) {
                const stagingIndexInChecked = this.checkStaging.findIndex(e => e.domain === row.staging.domain)
                if (stagingIndexInChecked !== -1) {
                  const domainObj = this.checkStaging[stagingIndexInChecked];
                  addon.staging.domain = domainObj.domain;
                  // addon.staging.ftp=domainObj.ftp;
                  // addon.staging.ftp.host = this.serverIP;
                  addon.staging.phpMyAdmin = domainObj.phpMyAdmin;
                  addon.staging.enabled = true;
                }
              }
              obj.addon.push(addon);
            }
            if (Number(obj.planLimit) < obj.addon.length + 1) {
              console.log('inside addon limit')
              obj.extraDomains = obj.addon.length + 1 - Number(obj.planLimit);
            }
            accounts.push(obj);
            planIndex = accounts.length - 1;
          }
          console.log('accounts', accounts)
          await this.addHostingAccountEventLog({hostingAccountId : this.docID ,  afterPayload: accounts , beforePayload: beforePayload, action: 'Fetch Domains' })
          await db.collection('hostingAccounts').doc(this.docID).update({accounts});

          try {
            const {firstName, lastName, docID: UID} = this.customerInfo;
            // this is for a client who is importing 1500-3000 sites so need to avoid monitor creation
            if(this.docID !== 'uUNvXYtlKBU7XX5Kzm4gG0aM9ZK2') {
              await this.$http.post("monitor/create-monitor-bulk", {
                customerId: UID,
                grant_type: "token",
                firstName,
                lastName,
                ip: this.serverIP,
                hostingAccountId: this.docID,
                selectedDomains: this.checkAll,
                type: 'fetch-domains'
              });
            }

          } catch (e) {
            console.error(e)
            console.log('something went wrong while updating better up time monitors', e.toString());
          }
          // save domains for collaborators
          try {
            await this.saveDomainsForCollaborators();
          } catch (e) {
            console.error(e)
            console.log('Something went wrong while assigning domains to collaborators', e.toString())
          }
          try {
            await this.$http.post("provider/check", {
              user_id: this.docID,
              cust_id: this.custID,
              grant_type: "token",
              email: this.user.email,
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              planIndex,
              domain: cloudflareDomain,
              ip: this.serverIP
            });
          } catch (e) {
            console.error(e)
            console.log('something went wrong while updating cloudflare settings', e.toString());
          }
          try {
            await this.$http.post('/algolia/reinitialize-user-all-record', {
              grant_type: 'token',
              uid: this.docID,
            })
          } catch (e) {
            console.error(e)
            console.log('Something went wrong while updating search indexes')
          }
          // update search index
          // add domains to domain collection
          for (const row of this.checkAll) {
            // await db.collection('domains').add({
            //   uid: this.docID,
            //   domain: row.domain,
            //   ip: this.serverIP,
            //   uuid: row.uuid,
            // });
            const ref = await db.collection('domains').where('ip', '==', this.serverIP).where('domain', '==', row.domain)
                .get();
            if (!ref.size) {
              await db.collection('domains').add({
                uid: this.docID,
                domain: row.domain,
                ip: this.serverIP,
                uuid: row.uuid,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString()
              });
            }
          }
          // try {
          //   await this.syncUuids()
          // } catch (e) {
          //   console.error(e)
          //   console.log('error at 635', e.toString())
          // }
          $("#fetchDomains").modal('hide');
          swal('Success', 'You have successfully synchronized the domains to WPO', 'success');

        }
      } catch (e) {
        console.log('error', e.toString())
        swal('Error', 'Something went wrong while synchronizing domains', 'error');

      } finally {
        this.finalLoader = false;

      }
    },
    ifExisting(domain) {
      return this.existingDomainsSet.has(domain);
    },
    load() {
      this.existingDomains = [];
      this.showDomains = false;
      this.submitLoader = false;
      this.finalLoader = false;
      this.serverDomains = [];
      this.domainPageNum = 0;
      this.domainSearchQuery = '';
      this.selectedValue = 'checkAll'
      this.serverIP = ''
      this.planList = [];
      this.newPlan = {
        details: null,
        primary: null,
        cloudflare: {
          username: '',
          password: '',
          apiKey: ''
        }
      }
      this.fetchPlans();

      $("#fetchDomains").modal('show');
    },
    checkIfPlanExists() {
      const planObj = this.existingDomains.find(el => el.serverIP === this.serverIP);
      return planObj ? true : false;
    },
    async fetchAllDomains() {
      try {
        this.showDomains = false;
        this.serverDomains = [];
        this.checkAll = [];
        this.checkStaging = [];
        if (!this.serverIP) {
          swal('Error!', 'Please provide the server IP to fetch domains!', 'error');
          return
        }
        this.submitLoader = true;
        const hostingAccounts = this.$store.getters["hosting/accountsOrdered"];
        hostingAccounts.forEach(el => {
          if (!el.deleted && el.serverIP === this.serverIP) {
            this.existingDomains.push(el);
            if (el.staging.enabled) {
              this.existingDomains.push(el.staging)
            }
          }
        });
        this.planExistsFlag = await this.checkIfPlanExists();
        const response = await this.$http.post("/domain/fetch-domains-from-server", {
          grant_type: "token",
          ip: this.serverIP
        })
        const raw = JSON.parse(response.data.data)
        // Defer UI update to next tick so main thread can breathe (avoids Chrome freeze)
        this.$nextTick(() => {
          requestAnimationFrame(() => {
            this.serverDomains = raw
            this.domainPageNum = 0
            this.checkAll = this.arrangedServerDomain.slice()
            this.checkStaging = this.stagingDomains.slice()
            this.selectedValue = 'checkAll'
            this.showDomains = true
          })
        })
      } catch (e) {
        console.log('error', e.toString())
      } finally {
        this.submitLoader = false;
      }
    },
    async addLiveToSelectedWithStaging(liveDomain) {
      const checkDomainIndex = this.checkAll.findIndex(e => e.domain === liveDomain.domain)
      if (checkDomainIndex === -1) {
        this.checkAll.push(liveDomain);
      }

    },
    async removeStagingWithLiveDomain(liveDomain) {
      if (liveDomain.staging) {
        const checkStagingIndex = this.checkStaging.findIndex(e => e.domain === liveDomain.staging.domain)
        if (checkStagingIndex !== -1) {
          this.checkStaging.splice(checkStagingIndex, 1)
        }
      }
    }
  }
}
</script>

<style scoped>
.scroll-area {
  height: 500px;
}

.bg-blue {
  background: #FFFAEC
}

.dotted-td {
  width: 20px !important;
  padding-right: 0;
}

.dotted-line-text {
  display: inline-flex;
  margin-top: 3px;
}

.dotted-line {
  width: 35px;
  border-left-style: dotted;
  height: 41px;
  margin: -30px 7px 0px 2px;
  border-color: #e7e9ea;;
  border-bottom-style: dotted;

}

.staging-domain {
  opacity: 0.5;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.4px;
  text-align: right;

  .side-div {
    width: 14px;
  }
}
.btn-outline-secondary[disabled]{
  color: white !important;
}

.staging-only-row .staging-domain {
  opacity: 1;
  font-size: 14px;
}

.staging-only-row {
  background-color: #f8f9fa;
}
</style>
